import React from "react";
import { CardPlanweekheader } from "../../components/CardPlanweekheader";
import { CmpAskcoachfab } from "../../components/CmpAskcoachfab";
import { CmpWorkoutcard } from "../../components/CmpWorkoutcard";
import { MobilityMiniCard } from "../../components/MobilityMiniCard";
import "./style.css";

export const PlanPeekModal = () => {
  return (
    <div className="plan-peek-modal" data-model-id="2256:781">
      <div className="rectangle-wrapper">
        <div className="rectangle" />
      </div>

      <CardPlanweekheader className="card-planweekheader-instance" />
      <CmpWorkoutcard
        className="design-component-instance-node-2"
        state="live"
      />
      <div className="cmp-mobilityminicard">
        <MobilityMiniCard
          className="mobility-mini-card-instance"
          clipPathGroup="/img/clip-path-group-2.png"
          elementMorningStretchClassName="mobility-mini-card-4"
          frameClassName="mobility-mini-card-2"
          img="/img/vector-5.svg"
          mobilityMiniCardClassName="mobility-mini-card-3"
          spanClassName="mobility-mini-card-5"
          spanClassNameOverride="mobility-mini-card-6"
          vector="/img/vector-4.svg"
        />
      </div>

      <CmpAskcoachfab className="design-component-instance-node-2" />
    </div>
  );
};
